import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Swipe', null, {
    withChildren: true,
});
